import * as urlUtils from 'utils/Url';


export function getPathControlAccounts(qs={}) {
  return urlUtils.appendQueryString(`/control/accounts`, qs);
}

export function getPathControlAccountDetails(accountId) {
  return `/control/accounts/${accountId}/details`;
}

export function getPathControlAccountCreditRecords(accountId, qs={}) {
  return urlUtils.appendQueryString(`/control/accounts/${accountId}/credit-records`, qs);
}

export function getPathControlAddAccountCredits(accountId) {
  return `/control/accounts/${accountId}/add-credits`;
}
